module.exports = __webpack_public_path__ + "img/5b0cebd5-408b-40a6-9e62-ba918269b90a.cb616f44.jpg";